module.exports = __webpack_public_path__ + "img/collection.a53de27f.png";